module.exports = "fragment OptionalYearDateFragment on OptionalYearDate {\n  __typename\n  day\n  month\n  year\n}\n"